import { render } from "./ProjectsTable.vue?vue&type=template&id=aaea8c1c&scoped=true"
import script from "./ProjectsTable.vue?vue&type=script&lang=js"
export * from "./ProjectsTable.vue?vue&type=script&lang=js"

import "./ProjectsTable.vue?vue&type=style&index=0&id=aaea8c1c&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src1847379700/src/basejumper-amplify/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aaea8c1c"]])

export default __exports__